// extracted by mini-css-extract-plugin
module.exports = {"thumbnails":"AuthorBlock_thumbnails__1s6x6","authorBlock":"AuthorBlock_authorBlock__MYxX_"};